/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateGrantPreferencesMutationRequest,
  UpdateGrantPreferencesMutationResponse,
  UpdateGrantPreferencesPathParams,
  UpdateGrantPreferences400,
  UpdateGrantPreferences403,
  UpdateGrantPreferences404,
  UpdateGrantPreferences500,
} from '../types/UpdateGrantPreferences'

function getUpdateGrantPreferencesUrl({
  grant_id,
}: {
  grant_id: UpdateGrantPreferencesPathParams['grant_id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/nylas/grants/${grant_id}/` as const,
  }
  return res
}

/**
 * @summary Update sharing flags, selected calendar, or remove a feature
 * {@link /api/v1/nylas/grants/:grant_id/}
 */
export async function updateGrantPreferences(
  { grant_id }: { grant_id: UpdateGrantPreferencesPathParams['grant_id'] },
  data?: UpdateGrantPreferencesMutationRequest,
  config: Partial<RequestConfig<UpdateGrantPreferencesMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateGrantPreferencesMutationResponse,
    ResponseErrorConfig<
      | UpdateGrantPreferences400
      | UpdateGrantPreferences403
      | UpdateGrantPreferences404
      | UpdateGrantPreferences500
    >,
    UpdateGrantPreferencesMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateGrantPreferencesUrl({ grant_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
